module.exports = __webpack_public_path__ + "static/img/gywm.11b81e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/gywm.png
// module id = ZQf2
// module chunks = 1